<template>
    <v-row class="justify-center align-center ma-1">
        <v-card class="col-10">
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text class="px-5">
                <v-col align-self="center">
                    <v-text-field
                        :label="$t('Name')"
                        v-model="flow.name"
                        :error-messages="nameErrors"
                        @input="$v.flow.name.$touch()"
                        @blur="$v.flow.name.$touch()"
                    ></v-text-field>
                    <v-select
                        multiple
                        v-model="flow.contentTypeIDs"
                        :items="contentTypesList"
                        item-text="Name"
                        item-value="Id"
                        v-bind:label="$t('ContentTypes')"
                        :error-messages="contentTypeIDsErrors"
                        @change="$v.flow.contentTypeIDs.$touch()"
                        @blur="$v.flow.contentTypeIDs.$touch()"
                    ></v-select>

                    <v-select
                        v-model="flow.defFieldCode"
                        :disabled="flow.id > 0"
                        :error-messages="statesFieldErrors"
                        @change="$v.flow.defFieldCode.$touch()"
                        @blur="$v.flow.defFieldCode.$touch()"
                        :items="availableStateFields"
                        item-text="Name"
                        item-value="Code"
                        v-bind:label="$t('Field')"
                    ></v-select>
                    <v-switch
                        v-model="flow.activeNotif"
                        :label="$t('EnableAlerts')"
                        @change="alertsConfigChanged"
                    ></v-switch>
                    <v-switch
                        :disabled="!flow.activeNotif"
                        v-model="flow.notifyByEmail"
                        :label="$t('NotifyByEmail')"
                    ></v-switch>
                </v-col>
                <v-row class="justify-end">
                    <v-btn @click="cancel()">{{ $t('Cancel') }}</v-btn>
                    <v-btn @click="saveItem" class="primary">{{ $t('Save') }}</v-btn>
                </v-row>
                <v-overlay :value="loading" :absolute="true">
                    <div class="text-center">
                        <v-progress-circular
                            class="my-4"
                            :size="50"
                            width="5"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                    </div>
                </v-overlay>
            </v-card-text>
        </v-card>
    </v-row>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import FlowService from '@/services/FlowService';
import Flow from '@/ecm/models/workflow/Flow';
import Utils from '@/ecm/common/Utils';

export default {
    name: 'Flow',
    created() {
        this.$v.$reset();
        if (isNaN(this.$route.params.id) || this.$route.params.id < 1) {
            this.new();
        } else
            this.edit(this.$route.params.id);
    },
    data() {
        return {
            contentTypesList: [],
            open: false,
            flow: new Flow(),
            isNew: true,
            loading: false,
        };
    },
    mixins: [validationMixin],
    validations: {
        flow: {
            name: { required },
            contentTypeIDs: { required },
            defFieldCode: { required },
        },
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        availableStateFields() {
            var selectedContentTypes = this.contentTypesList.filter((ct) =>
                this.flow.contentTypeIDs.includes(ct.Id)
            );

            var selectedContentTypesFields = selectedContentTypes.flatMap(
                (x) => x.DefFields
            );

            var fieldsInAllContentSelectedContentTypes = selectedContentTypesFields.filter(
                (x) =>
                    selectedContentTypes.every((ct) =>
                        ct.DefFields.some((df) => df.Code == x.Code)
                    )
            );

            return fieldsInAllContentSelectedContentTypes;
        },
        title() {
            return this.$t('Flow') + (this.flow.name ? ' - ' + this.flow.name : '');
        },
        statesFieldErrors() {
            const errors = [];
            if (!this.$v.flow.defFieldCode.$dirty) return errors;
            !this.$v.flow.defFieldCode.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
        contentTypeIDsErrors() {
            const errors = [];
            if (!this.$v.flow.contentTypeIDs.$dirty) return errors;
            !this.$v.flow.contentTypeIDs.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
        nameErrors() {
            const errors = [];
            if (!this.$v.flow.name.$dirty) return errors;
            !this.$v.flow.name.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
    },
    methods: {
        getContentTypes(id) {
            this.loading = true;
            FlowService.getAvailableContentTypes(id).then((data) => {
                this.contentTypesList = data;
            }).catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        saveItem() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.loading = true;

            FlowService.save(this.flow.toDto())
                .then((result) => {
                    if (result) {
                        if (this.isNew) {
                            Utils.toast.success(
                                this.$t('Flow') +
                                    ' ' +
                                    this.$t('CreatedSuccessfully')
                            );
                        } else {
                            Utils.toast.success(
                                this.$t('Flow') +
                                    ' ' +
                                    this.$t('UpdatedSuccessfully')
                            );
                        }
                        this.$router.push('/administration/flows');
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        alertsConfigChanged() {
            if (!this.flow.activeNotif) {
                this.flow.notifyByEmail = false;
            }
        },
        new() {
            this.isNew = true;
            this.flow = new Flow();
            this.getContentTypes();
        },
        edit(id) {
            this.loading = true;
            FlowService.getFlowById(id).then((data) => {
                this.flow = new Flow(data);
                this.isNew = false;
                this.getContentTypes(this.flow.id);
            })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$router.push('/administration/flows');
        }
    },
};
</script>
